import { HealthConcernsSection } from "@/features/patient/clinical-history/components/HealthConcernsView";
import { useHealthConcerns } from "@/features/patient/clinical-history/utils/adaptClinicalHistory";

export function HealthConcernsPage() {
  const { concerns, patientConcerns, isLoading } = useHealthConcerns();
  return (
    <HealthConcernsSection
      concerns={concerns}
      patientConcerns={patientConcerns}
      isLoading={isLoading}
    />
  );
}
